import React from 'react'
import { css } from '@emotion/core'
import { Row, Separator } from '@fs/zion-ui'
import maleTwigs from './maleTwigs.svg'
import femaleTwigs from './femaleTwigs.svg'
import FSLogo from '../../../../../shared/assets/fs-logo.svg'
import maleIcon from '../../../../../shared/assets/male.svg'
import femaleIcon from '../../../../../shared/assets/female.svg'

export default function RelativeTakeaway({ heading = '', subHeading = '', relation = '', gender, profile }) {
  const splash = gender === 'male' ? maleTwigs : femaleTwigs
  const borderColor = gender === 'male' ? '#3FCDE3' : '#DD2762'

  if (!profile) {
    profile = gender === 'male' ? maleIcon : femaleIcon
  }

  const takeawayCss = css`
    width: 100%;
    box-sizing: border-box;
    border: 16px solid ${borderColor};
    background: white;
    position: relative;
    text-align: center;
    font-family: arial;
    font-size: 30px;
  `

  const splashCss = css`
    width: 100%;
  `

  const profileCss = css`
    position: absolute;
    top: 100px;
    width: 100%;
    display: flex;
    justify-content: center;
    > img {
      border: 10px solid ${borderColor};
      background: ${borderColor};
      width: 320px;
      height: 320px;
      border-radius: 50%;
    }
  `

  return (
    <div css={takeawayCss}>
      <img alt="Splash" crossOrigin="anonymous" src={splash} css={splashCss} />
      <div css={profileCss}>
        <img alt="profile" crossOrigin="anonymous" src={profile} />
      </div>
      <Separator size="xl" />
      {relation && (
        <>
          <span>{relation}</span>
          <Separator />
        </>
      )}

      <span style={{ fontSize: '40px' }}>{heading}</span>
      <Separator size="xs" />
      <span>{subHeading}</span>
      <Separator />
      <Row alignX="center">
        <img alt="Logo" src={FSLogo} />
      </Row>
      <Separator />
    </div>
  )
}
